import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { useAuthInfo } from "../lib/apis/hooks/auth.hook";
import { useNavigate } from "react-router-dom";
import { useLoginStore } from "../store/useLoginStore";
import { useModalStore } from "../store/useModalStore";
import { loginByloginId } from "../lib/apis/v1/auth.service";
import FailSnackbar from "../components/ui/snackbar/fail.component";
import { useEnterKey } from "../lib/hooks/useEnterKey";
import Button from "../components/ui/button";
import { useAuth, type Auth } from "../store/useAuthStore";
import { MODAL_KEY } from "../lib/constants/modal.constants";
import dayjs from "dayjs";

export default function LoginPage() {
  const { refetch } = useQuery({ ...useAuthInfo(), enabled: false });
  const navigate = useNavigate();

  const { setAccess } = useLoginStore();
  const setAuth = useAuth((state) => state.setAuth);
  const { openModal } = useModalStore();

  // STATE
  const [form, setForm] = useState({
    loginId: "",
    password: "",
  });

  // HANDLER
  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;

    setForm((state) => ({ ...state, [id]: value }));
  };

  const clickHandler = React.useCallback(async () => {
    for (const value in form) {
      if (!value) return alert("아이디 또는 비밀번호를 입력해주세요.");
    }

    try {
      const { code, result: response } = await loginByloginId(form);

      if (code !== 200 || !response.accessToken) {
        FailSnackbar("아이디, 비밀번호를 확인해주세요.");
        return;
      }

      setAccess({
        email: form.loginId,
        refreshToken: response.refreshToken,
        accessToken: response.accessToken,
        expiresAt: dayjs().add(30, 'minutes').unix(),
      });

      const result = await refetch();
      const userResponse = result.data;

      if (!userResponse || userResponse.code !== 200) {
        FailSnackbar("사용자 정보를 불러오지 못했습니다.")
      }

      const role = userResponse?.result.role;

      const auth = {
        id: userResponse?.result.userId,
        ownerId: userResponse?.result.ownerId,
        phone: userResponse?.result.phone,
        stores: userResponse?.result.stores,
        username: userResponse?.result.username,
        role: role,
        createdDate: userResponse?.result.createDate,
        activeStoreNum: userResponse?.result.activeStoreNum,
      } as unknown as Auth;
      setAuth(auth);

      if (role) {
        navigate("/");
      }

    } catch (error) {
      FailSnackbar("관리자에게 문의해주시기 바랍니다.")
    }
  }, [form]);

  useEnterKey(clickHandler);

  return (
    <div>
      <div className="flex flex-col justify-center items-center w-[100%] h-[100vh]">
        <h2 className="text-[30px]  ">로그인 해주세요.</h2>
        <p className="text-[rgba(0,0,0,0.60)]  mb-[32px]">
          부여받은 아이디와 비밀번호를 입력해주세요.
        </p>
        <input
          className="w-[520px] h-[56px] px-[12px] mb-[16px] border rounded-[3px] border-[rgba(0,0,0,0.23)] "
          placeholder="Email"
          id="loginId"
          value={form.loginId}
          onChange={changeHandler}
        />
        <input
          className="w-[520px] h-[56px] px-[12px] mb-[16px] border rounded-[3px] border-[rgba(0,0,0,0.23)] "
          placeholder="Password"
          id="password"
          type="password"
          value={form.password}
          onChange={changeHandler}
        />
        <Button
          className="bg-black text-[#ffffff] w-[520px] h-[42px] rounded-[4px]"
          label="로그인"
          onClick={clickHandler}
        />
        <div className="flex flex-row justify-between items-center w-[520px] mt-[30px]">
          <p className="text-[rgba(0,0,0,0.60)]  ">
            로그인이 되지 않거나 궁금한 사항이 있다면 문의해주세요.
          </p>
          <p
            className="text-[#1976D2]  underline cursor-pointer "
            onClick={() =>
              openModal(MODAL_KEY.InquiryCreate, {})
              // openModal("CONFIRM_MODAL", {
              //   title: "문의하기",
              //   rightButton: {
              //     title: "문의하기",
              //     onClick: () => {
              //       console.log("hi");
              //     },
              //   },
              //   children: (
              //     <div className="flex flex-col py-4 gap-4">
              //       <TextField
              //         className="w-[552px] h-[52px]"
              //         label="답변 받으실 이메일"
              //         slotProps={{ inputLabel: { shrink: true } }}
              //       />
              //       <TextField
              //         multiline
              //         maxRows={9}
              //         className="w-[552px]"
              //         size="medium"
              //         label="문의 내용"
              //         slotProps={{
              //           inputLabel: { shrink: true },
              //           input: {
              //             sx: {
              //               height: 200,
              //               alignItems: "flex-start",
              //             },
              //           },
              //         }}
              //       />
              //     </div>
              //   ),
              // })
            }
          >
            문의하기
          </p>
        </div>
      </div>
    </div>
  );
}
